import React from "react";
import { Col, Container, Row } from "reactstrap";

import icon from "../assets/images/icona.png";
import { useNavigate } from "react-router-dom";
import ServicesCard from "./ServicesCard";

// Services data

const ServicesData = [
  {
    imgsrc: icon,
    title: "Vendita",
    caption:
      "Offriamo ai nostri clienti una vastissima gamma di Gruppi elettrogeni, Torri faro e UPS gruppi di continuità nuovi in pronta consegna o su ordinazione, scelti tra le migliori marche presenti sul mercato mondiale come Pramac, Mahindra e Mosa.",
      isShadow: true,
    },
  {
    imgsrc: icon,
    title: "Noleggio",
    caption:
      "Noleggiamo Gruppi elettrogeni e Torri faro con forme di locazione vantaggiose e personalizzate a breve e a lungo termine.",
    isShadow: true,
  },
  {
    imgsrc: icon,
    title: "Assistenza",
    caption:
      "Assistenza, Controlli, Ricerca e Soluzione, Verifiche, Pratiche U.T.F., Manutenzione, Cunsulenze e Sicurezza sul lavoro.",
    isShadow: true,
    },
  {
    imgsrc: icon,
    title: "Ricambi",
    caption:
      "Disponiamo per chiunque lo necessiti, una vastissima gamma di ricambi  sia pronta consegna che su ordinazione.",
      isShadow: true,
  }
];

const Services = () => {
  const navigate = useNavigate()
  const goToService = (title,isShadow) => {
    if (isShadow){
      navigate(`/servizi/${title}`)
    }
  }
  return (
    <>
      <section className="section" id="services">
        <Container>
          <Row>
            {/* Services Component Start */}
            {ServicesData.map((value, idx) => (
              <ServicesCard
                key={idx}
                imgsrc={value.imgsrc}
                title={value.title}
                caption={value.caption}
                isShadow={value.isShadow}
                onClick={() => goToService(value.title,value.isShadow)}/>
            ))}

            {/* Services Component End */}
          </Row>
        </Container>
      </section>
    </>
  );
}

export default Services;
